import { AfterViewInit, Directive, Host } from '@angular/core';

import { TwcSelectOptionComponent } from '@topcon/twc-angular';

/**
 * This directive helps fixing the issue 2 described in the WinuiSelectFixDirective directive.
 * Issue: Dropdown menu will be closed by the on mouse down event, so a touch scroll attempt will close the menu.
 * - Fix 2.2: We change the on mouse down event by an on click event.
 * -- Only a full click will select an option and close the menu
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'twc-select-option',
    standalone: false,
})
export class WinuiSelectOptionFixDirective implements AfterViewInit {
    constructor(@Host() private twcSelectOption: TwcSelectOptionComponent) {}

    /**
     * We call handleMousedown logic on click
     */
    // @HostListener('click', ['$event'])
    // onClick(event: MouseEvent): void {
    //     this.twcSelectOption.handleMousedown(event);
    // }
    // eslint-disable-next-line
    ngAfterViewInit(): void {
        // ! This function rewrite uses the current twc-select-option code and may break with future twc-select-option component updates.
        // this.twcSelectOption.handleMousedown = async function (this: TwcSelectOptionComponent, event: MouseEvent): Promise<void> {
        //     const isClick = event.type === 'click';
        //     // We block any atempt of running the logic without being a click
        //     if (!this.isDisabled && isClick) {
        //         event.stopPropagation();
        //         event.preventDefault();
        //         this.selected.next(this);
        //     }
        // }.bind(this.twcSelectOption);
    }
}
